<template>
  <div v-if="isVisible" class="modal-backdrop" @click="close">
    <div class="login-box" @click.stop>
      <div class="basket">
        <!-- Header -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <h3 style="color: white; margin: 0; font-size: 20px; font-weight: bold; font-family: IRANSansWeb;">
            حافظه ذخیره شده
          </h3>
          <i @click="close" class="fa-solid fa-x" 
             style="margin-top: 5px; font-size: 20px; color: white; cursor: pointer;"></i>
        </div>

        <!-- Description -->
        <p style="color: #ccc; font-size: 14px; margin-bottom: 20px; line-height: 1.6; text-align: right;">
          روبو سعی می‌کند گفتگوهای اخیر شما را به خاطر بسپارد، اما ممکن است با گذشت زمان چیزهایی را فراموش کند. 
          حافظه‌های ذخیره شده هرگز فراموش نمی‌شوند.
        </p>
        
        <!-- Loading State -->
        <div v-if="loading" class="loading-container">
          <i class="fa-solid fa-spinner fa-spin" style="color: #6153cc; font-size: 24px;"></i>
          <p style="color: #ccc; margin-top: 10px; font-size: 14px;">در حال بارگذاری...</p>
        </div>
        
        <!-- Empty State -->
        <div v-else-if="memories.length === 0" class="no-memories">
          <i class="fa-solid fa-brain" style="color: #6153cc; font-size: 48px; margin-bottom: 16px;"></i>
          <p style="color: #ccc; font-size: 16px;">هنوز حافظه‌ای ذخیره نشده</p>
        </div>
        
        <!-- Memories List -->
        <div v-else class="memories-list">
          <div v-for="memory in memories" :key="memory.id" class="memory-item">
            <div class="memory-content">
              <p class="memory-text">{{ memory.text }}</p>
              <button @click="deleteMemory(memory.id)" class="delete-btn" title="حذف حافظه">
                <i class="fa-solid fa-trash" style="color: #ff6b6b; font-size: 14px;"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div v-if="memories.length > 0" style="margin-top: 20px; text-align: center;">
          <button type="button" class="btn-delete-all" @click="deleteAllMemories">
            <i class="fa-solid fa-trash" style="margin-left: 8px;"></i>
            حذف همه
          </button>
        </div>
      </div>
    </div>
    
    <!-- Delete All Confirmation Modal -->
    <div v-if="showDeleteConfirm" class="modal-backdrop" @click="cancelDeleteAll">
      <div class="confirm-modal" @click.stop>
        <div class="confirm-content">
          <!-- Header -->
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <h3 style="color: white; margin: 0; font-size: 18px; font-weight: bold; font-family: IRANSansWeb;">
              تأیید حذف
            </h3>
            <i @click="cancelDeleteAll" class="fa-solid fa-x" 
               style="margin-top: 5px; font-size: 18px; color: white; cursor: pointer;"></i>
          </div>
          
          <!-- Message -->
          <p style="color: #ccc; font-size: 14px; margin-bottom: 25px; line-height: 1.6; text-align: right;">
            آیا مطمئن هستید که می‌خواهید همه حافظه‌های ذخیره شده را حذف کنید؟ این عمل قابل بازگشت نیست.
          </p>
          
          <!-- Buttons -->
          <div style="display: flex; gap: 10px; justify-content: center;">
            <button @click="cancelDeleteAll" class="btn-cancel">
              <i class="fa-solid fa-times" style="margin-left: 8px;"></i>
              لغو
            </button>
            <button @click="confirmDeleteAll" class="btn-confirm">
              <i class="fa-solid fa-trash" style="margin-left: 8px;"></i>
              حذف همه
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MemoryManagementModal',
  data() {
    return {
      isVisible: false,
      memories: [],
      loading: false,
      showDeleteConfirm: false
    };
  },
  methods: {
    open() {
      this.isVisible = true;
      this.loadMemories();
      // Add escape key listener
      document.addEventListener('keydown', this.handleEscapeKey);
    },
    close() {
      this.isVisible = false;
      // Remove escape key listener
      document.removeEventListener('keydown', this.handleEscapeKey);
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    },
    async loadMemories() {
      this.loading = true;
      try {
        const response = await axios.get('https://api.roboo.ir/api/usermemory/GetMemories', {
          params: {
            token: localStorage.getItem('token')
          }
        });
        
        if (response.data && Array.isArray(response.data)) {
          this.memories = response.data;
        } else {
          this.memories = [];
        }
      } catch (error) {
        console.error('Failed to load memories:', error);
        this.memories = [];
      } finally {
        this.loading = false;
      }
    },
    async deleteMemory(memoryId) {
      try {
        const response = await axios.post('https://api.roboo.ir/api/usermemory/deleteMemory', {
          token: localStorage.getItem('token'),
          id: memoryId
        });
        
        if (response.data === true) {
          // Remove from local list
          this.memories = this.memories.filter(memory => memory.id !== memoryId);
        }
      } catch (error) {
        console.error('Failed to delete memory:', error);
      }
    },
    async deleteAllMemories() {
      this.showDeleteConfirm = true;
    },
    async confirmDeleteAll() {
      try {
        const response = await axios.post('https://api.roboo.ir/api/usermemory/deleteAllMemories', {
          token: localStorage.getItem('token')
        });
        
        if (response.data === true) {
          this.memories = [];
        }
      } catch (error) {
        console.error('Failed to delete all memories:', error);
      } finally {
        this.showDeleteConfirm = false;
      }
    },
    cancelDeleteAll() {
      this.showDeleteConfirm = false;
    }
  },
  beforeUnmount() {
    // Clean up event listener when component is destroyed
    document.removeEventListener('keydown', this.handleEscapeKey);
  }
};
</script>

<style scoped>
/* Import app fonts */
@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

/* Modal backdrop with blur effect */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: backdropFadeIn 0.3s ease-out;
  overflow-y: auto;
  min-height: 100vh;
  min-width: 100vw;
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
}

/* Mobile-first responsive design */
.login-box {
  position: relative;
  background-color: rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  border-radius: 10px;
  max-height: 85vh;
  overflow-y: auto;
  width: 100%;
  max-width: 90vw;
  margin: 0 auto;
  left: 0;
  top: 0;
  transform: none;
  align-self: center;
}

.basket {
  background-color: rgb(24, 24, 24);
  border-radius: 10px;
  max-height: 75vh;
  overflow-y: auto;
}

/* Custom scrollbar for basket */
.basket::-webkit-scrollbar {
  width: 6px;
}

.basket::-webkit-scrollbar-track {
  background: #212529;
  border-radius: 3px;
}

.basket::-webkit-scrollbar-thumb {
  background: #6153cc;
  border-radius: 3px;
}

.basket::-webkit-scrollbar-thumb:hover {
  background: #7c6fdd;
}

/* Loading and empty states */
.loading-container,
.no-memories {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

/* Memories list */
.memories-list {
  max-height: 40vh;
  overflow-y: auto;
  margin-bottom: 10px;
  padding-right: 5px;
}

.memory-item {
  background-color: #212529;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #333;
  transition: all 0.3s ease;
}

.memory-item:hover {
  background-color: #2a2d32;
  border-color: #6153cc;
}

.memory-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.memory-text {
  flex: 1;
  color: white;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  text-align: right;
  word-wrap: break-word;
  font-family: IRANSansWeb;
}

.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}

.delete-btn:hover {
  background-color: rgba(255, 107, 107, 0.1);
  transform: scale(1.1);
}

.btn-delete-all {
  background: linear-gradient(90deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: IRANSansWeb;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.btn-delete-all:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
}

.btn-delete-all:active {
  transform: translateY(0);
}

/* Custom scrollbar */
.memories-list::-webkit-scrollbar {
  width: 6px;
}

.memories-list::-webkit-scrollbar-track {
  background: #212529;
  border-radius: 3px;
}

.memories-list::-webkit-scrollbar-thumb {
  background: #6153cc;
  border-radius: 3px;
}

.memories-list::-webkit-scrollbar-thumb:hover {
  background: #7c6fdd;
}

/* Tablet styles */
@media (min-width: 768px) {
  .login-box {
    max-width: 80vw;
    width: 600px;
  }
  
  .memory-text {
    font-size: 15px;
  }
  
  .memories-list {
    max-height: 50vh;
  }
}

/* Desktop styles */
@media (min-width: 1024px) {
  .login-box {
    max-width: 70vw;
    width: 700px;
  }
  
  .memory-text {
    font-size: 16px;
  }
  
  .memories-list {
    max-height: 55vh;
  }
}

/* Large desktop styles */
@media (min-width: 1440px) {
  .login-box {
    max-width: 60vw;
    width: 800px;
  }
  
  .memories-list {
    max-height: 60vh;
  }
}

/* Animation for modal appearance */
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Ensure proper centering on all devices */
@media (max-width: 767px) {
  .modal-backdrop {
    padding: 10px;
    align-items: center;
    justify-content: center;
  }
  
  .login-box {
    max-width: 95vw;
    margin: 0 auto;
  }
}

/* Fix for very small screens */
@media (max-width: 480px) {
  .login-box {
    max-width: 98vw;
    margin: 0 auto;
  }
  
}

/* RTL support */
[dir="rtl"] .memory-content {
  flex-direction: row-reverse;
}

[dir="rtl"] .memory-text {
  text-align: right;
}

/* Focus states for accessibility */
.delete-btn:focus,
.btn-delete-all:focus {
  outline: 2px solid #6153cc;
  outline-offset: 2px;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .memory-item {
    border: 2px solid #fff;
  }
  
  .memory-text {
    color: #fff;
  }
}

/* Confirmation Modal Styles */
.confirm-modal {
  background-color: rgb(24, 24, 24);
  border-radius: 10px;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  max-width: 400px;
  width: 90vw;
  animation: modalSlideIn 0.3s ease-out;
}

.confirm-content {
  padding: 25px;
}

.btn-cancel {
  background: linear-gradient(90deg, #6c757d 0%, #5a6268 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: IRANSansWeb;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}

.btn-confirm {
  background: linear-gradient(90deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: IRANSansWeb;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
}

.btn-cancel:active,
.btn-confirm:active {
  transform: translateY(0);
}

/* Focus states for confirmation buttons */
.btn-cancel:focus,
.btn-confirm:focus {
  outline: 2px solid #6153cc;
  outline-offset: 2px;
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .modal-backdrop,
  .login-box,
  .confirm-modal,
  .memory-item,
  .delete-btn,
  .btn-delete-all,
  .btn-cancel,
  .btn-confirm {
    transition: none;
    animation: none;
  }
}
</style>
